<span [ngClass]="['flow-chip', 'size-' + size.toLowerCase(), 'type-' + type.toLowerCase(), 'color-' + color.toLowerCase(), disabled ? 'disabled' : '']">
  <span class="chip-body">
    @if (icon) {
      <span class="icon-wrapper" aria-hidden="true">
        <img [src]="icon" class="icon" />
      </span>
    }
    <span #label class="chip-text" agText="body-3-medium" style="font-size: 14px" [matTooltip]="text" [matTooltipDisabled]="!truncated">{{ text }}</span>
  </span>
  <button type="button" class="close-button" aria-label="Remove" [disabled]="disabled" (click)="onClose()">
    <img [src]="iconService.Icon.cross" class="icon" />
  </button>
</span>
